<div class="edit-credit-flow-node-dialog">
  <mat-dialog-content>
    <h3 class="header">Connect to Another Credit Flow</h3>
    <div class="row">
      <div class="col-12">
        <mat-form-field>
          <mat-label>Conditions to connect to the other flow</mat-label>
          <mat-select [formControl]="formControlCondition">
            @for (option of creditRuleItemOptions; track option) {
              <mat-option [value]="option.id">{{option.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <mat-form-field>
          <mat-label>Connected Credit Flow</mat-label>
          <mat-select [formControl]="formControlCreditFlowId">
            @for (option of creditFlowOptions; track option) {
              <mat-option [value]="option.id">{{option.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-6 col-md-12">
        <mat-form-field>
          <mat-label>Status for Current Flow</mat-label>
          <mat-select [formControl]="formControlStatus">
            @for (option of creditAlertStatusOptions; track option) {
              <mat-option [value]="option">{{option}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" class="width-100">
          <button color="primary" (click)="onCancel()" mat-stroked-button>Close</button>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
            <button color="primary" (click)="onClear()" mat-flat-button>Clear the connection</button>
            <button color="primary" [disabled]="!formGroup.valid" (click)="onSubmit()" mat-flat-button>Confirm</button>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
